import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Loader from '../spinner';
import Button from '../button/index';
import { DARK } from '../button/variants';
import css from './index.scss';
import messages from './messages';
import ClassDetail from '../class-detail/index';
import ClassEditGroup from '../../components/edit-class-group/index';
import AssignedTeacher from '../assigned-teacher-class/index';
import AddGroup from '../../components/add-group/index';
import ChangeCourse from '../../components/change-course/index';
import RenameGroup from '../rename-group/index';
import DeleteGroup from './delete-group';

const EditClassForm = (props) => {
    const {
        intl,
        handleOnCloseEditClass,
        isLoadingEditClassDetail,
        classroomDetail,
        yearGroups,
        downloadStudentSignInCards,
        isDownloadingSignInCards,
        handleOnClassNameChange,
        canSubmit,
        className,
        editClassGroupIsVisible,
        selectedGroup,
        selectedProduct,
        isSelectedGroupDefault,
        hideEditClassGroup,
        showEditClassGroup,
        handleOnRenameGroup,
        showRenameGroupConfirmationModal,
        handleOnCloseDeleteGroupConfirmation,
        handleOnCloseDeleteGroupModal,
        handleOnCloseRenameGroupModal,
        handleOnCancelRenameGroupModal,
        handleOnShowRenameGroupModal,
        showRenameGroupModal,
        isRenameGroupInProgress,
        handleOnCloseValidationModal,
        handleOnOkRenameGroup,
        showRenameGroupConfirmationBeforeSubmit,
        handleOnCancelRenameGroupConfirmationBeforeSubmit,
        yearGroup,
        handleOnYearGroupChange,
        handleOnCloseRenameGroupConfirmation,
        handleOnSaveClass,
        handleOnTeacherUnassign,
        showModal,
        handleOnUnassignConfirm,
        isUserOperationModalOpen,
        handleOnCloseModal,
        isLoading,
        teachersOperationSuccessConfirmation,
        isSavingClass,
        handleOnPrintTeacherSignInCard,
        downloadingTeachersIds,
        handleOnAssignTeacher,
        handleOnDeleteGroup,
        isDeletingGroupInProgress,
        showDeleteNonEmptyGroupConfirmationModal,
        showDeleteGroupConfirmation,
        showDeleteGroupConfirmationBeforeSubmit,
        handleOnDeleteNonEmptyGroup,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        handleOnDeleteGroupRequest,
        openChangeCourse,
        changeCourseIsActive,
        changeCourseClassroomId,
        changeCourseGroupId,
        addGroupIsActive,
        openAddGroup,
        closeAddGroup,
        addGroup,
        addGroupInProgress,
        addGroupIsSuccess,
        addGroupAddedGroup,
        handleOnManageStudents,
        handleOnManageStudentsBeforeDeleteGroup,
        addGroupExceedGroupError,
        handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards,
        showHideSignInCardModal,
        displayNewCourses
    } = props;
    const selectedCourseName = selectedGroup ? selectedGroup.courseTitle : '';
    const selectedUPFCourseName = selectedGroup ? selectedGroup.upfCourseTitle : '';
    const selectedNewCourseName = selectedGroup ? selectedGroup.conquestCourseTitle : '';
    const editClassWithoutScroll = showRenameGroupModal || editClassGroupIsVisible || changeCourseIsActive || addGroupIsActive;

    const addGroupProps = {
        addGroup,
        addGroupAddedGroup,
        addGroupExceedGroupError,
        addGroupInProgress,
        addGroupIsSuccess,
        classroomDetail,
        closeAddGroup,
        isActive: addGroupIsActive,
        openAddGroup,
        openChangeCourse,
        handleOnManageStudents,
        selectedProduct,
        handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards,
        showHideSignInCardModal,
        displayNewCourses
    };

    const changeGroupProps = {
        classroomId: changeCourseClassroomId,
        groupId: changeCourseGroupId,
        displayNewCourses
    };

    const renameGroupProps = {
        handleOnCancelRenameGroupConfirmationBeforeSubmit,
        handleOnCancelRenameGroupModal,
        handleOnCloseRenameGroupConfirmation,
        handleOnCloseRenameGroupModal,
        handleOnOk: handleOnOkRenameGroup,
        handleOnRenameGroup,
        isRenameGroupInProgress,
        selectedGroup,
        showRenameGroupConfirmationBeforeSubmit,
        showRenameGroupConfirmationModal
    };

    const deleteGroupProps = {
        classTitle: classroomDetail.name,
        courseName: selectedCourseName,
        handleOnChangeCourse: openChangeCourse,
        handleOnCloseDeleteGroupConfirmation,
        handleOnCloseDeleteGroupModal,
        handleOnCloseModal,
        handleOnDeleteGroup,
        handleOnDeleteGroupRequest,
        handleOnDeleteNonEmptyGroup,
        handleOnManageStudents,
        handleOnManageStudentsBeforeDeleteGroup,
        handleOnShowRenameGroupModal,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        isDefaultGroup: isSelectedGroupDefault,
        isDeletingGroupInProgress,
        selectedGroup,
        showDeleteNonEmptyGroupConfirmationModal,
        showDeleteGroupConfirmation,
        showDeleteGroupConfirmationBeforeSubmit
    };

    const classEditGroupProps = {
        changeCourseIsActive,
        classTitle: classroomDetail.name,
        courseName: selectedCourseName,
        upfCourseName: selectedUPFCourseName,
        newCourseName: selectedNewCourseName,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        handleOnChangeCourse: openChangeCourse,
        handleOnCloseDeleteGroupConfirmation,
        handleOnCloseDeleteGroupModal,
        handleOnCloseModal: hideEditClassGroup,
        handleOnCloseValidationModal,
        handleOnDeleteGroup,
        handleOnDeleteGroupRequest,
        handleOnDeleteNonEmptyGroup,
        handleOnManageStudents,
        handleOnManageStudentsBeforeDeleteGroup,
        handleOnOkRenameGroup,
        handleOnShowRenameGroupModal,
        isDefaultGroup: isSelectedGroupDefault,
        isDeletingGroupInProgress,
        selectedGroup,
        selectedProduct,
        showDeleteGroupConfirmation,
        showDeleteGroupConfirmationBeforeSubmit,
        showDeleteNonEmptyGroupConfirmationModal
    };

    const isDeleteGroupActive = showDeleteNonEmptyGroupConfirmationModal ||
    showDeleteGroupConfirmationBeforeSubmit ||
    showDeleteGroupConfirmation;

    const editClassView = isLoadingEditClassDetail === false ?
        (<div className={editClassWithoutScroll ? css.editClassWithoutScroll : css.editClass}>
            <div className={css.className}>{className}</div>
            <div className={css.classDetails}>
                <ClassDetail
                    className={className}
                    classroomDetail={classroomDetail}
                    downloadStudentSignInCards={downloadStudentSignInCards}
                    handleOnClassNameChange={handleOnClassNameChange}
                    handleOnEditGroup={showEditClassGroup}
                    handleOnSaveClass={handleOnSaveClass}
                    handleOnYearGroupChange={handleOnYearGroupChange}
                    isDownloadingSignInCards={isDownloadingSignInCards}
                    yearGroup={yearGroup}
                    yearGroups={yearGroups}
                    {...addGroupProps} />
                <AssignedTeacher
                    downloadingTeachersIds={downloadingTeachersIds}
                    handleOnAssignTeacher={handleOnAssignTeacher}
                    handleOnCloseModal={handleOnCloseModal}
                    handleOnPrintTeacherSignInCard={handleOnPrintTeacherSignInCard}
                    handleOnTeacherUnassign={handleOnTeacherUnassign}
                    handleOnUnassignConfirm={handleOnUnassignConfirm}
                    isLoading={isLoading}
                    isUserOperationModalOpen={isUserOperationModalOpen}
                    showModal={showModal}
                    teachers={classroomDetail.teachers}
                    teachersOperationSuccessConfirmation={teachersOperationSuccessConfirmation} />
                <div className={css.classFooter}>
                    <div className={css.buttonContainer}>
                        <Button
                            containerClassName={css.cancelButton}
                            disabled={isSavingClass}
                            handleOnClick={handleOnCloseEditClass}
                            label={intl.formatMessage((messages.cancel))}
                            variant={DARK} />
                        <Button
                            containerClassName={css.saveButton}
                            disabled={!canSubmit || isSavingClass}
                            handleOnClick={handleOnSaveClass}
                            label={intl.formatMessage(messages.save)}
                            variant={DARK} />
                    </div>
                </div>
            </div>

            <ClassEditGroup isActive={editClassGroupIsVisible && !isDeleteGroupActive} {...classEditGroupProps} />

            <AddGroup {...addGroupProps} />

            <ChangeCourse {...changeGroupProps} />

            <RenameGroup isActive={showRenameGroupModal} {...renameGroupProps} />

            <DeleteGroup isActive={isDeleteGroupActive} {...deleteGroupProps} />
        </div>)
        : (
            <div className={css.loader}>
                <Loader color="grey" size="15px" />
            </div>
        );

    return editClassView;
};

EditClassForm.propTypes = {
    intl: intlShape.isRequired,
    handleOnCloseEditClass: PropTypes.func,
    isLoadingEditClassDetail: PropTypes.bool,
    classroomDetail: PropTypes.object,
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    downloadStudentSignInCards: PropTypes.func,
    isDownloadingSignInCards: PropTypes.bool,
    handleOnClassNameChange: PropTypes.func,
    canSubmit: PropTypes.bool,
    className: PropTypes.string,
    editClassGroupIsVisible: PropTypes.bool,
    selectedGroup: PropTypes.object,
    selectedProduct: PropTypes.object,
    isSelectedGroupDefault: PropTypes.bool,
    showEditClassGroup: PropTypes.func,
    hideEditClassGroup: PropTypes.func,
    handleOnRenameGroup: PropTypes.func,
    showRenameGroupConfirmationModal: PropTypes.bool,
    handleOnCloseDeleteGroupModal: PropTypes.func,
    handleOnCloseRenameGroupModal: PropTypes.func,
    handleOnCancelRenameGroupModal: PropTypes.func,
    isRenameGroupInProgress: PropTypes.bool,
    handleOnShowRenameGroupModal: PropTypes.func,
    showRenameGroupModal: PropTypes.bool,
    handleOnCloseValidationModal: PropTypes.func,
    handleOnOkRenameGroup: PropTypes.func,
    handleOnCancelRenameGroupConfirmationBeforeSubmit: PropTypes.func,
    showDeleteGroupConfirmation: PropTypes.bool,
    showRenameGroupConfirmationBeforeSubmit: PropTypes.bool,
    handleOnYearGroupChange: PropTypes.func,
    yearGroup: PropTypes.string,
    handleOnCloseRenameGroupConfirmation: PropTypes.func,
    handleOnSaveClass: PropTypes.func,
    handleOnTeacherUnassign: PropTypes.func,
    showModal: PropTypes.bool,
    handleOnUnassignConfirm: PropTypes.func,
    isUserOperationModalOpen: PropTypes.bool,
    handleOnCloseModal: PropTypes.func,
    isLoading: PropTypes.bool,
    teachersOperationSuccessConfirmation: PropTypes.func,
    isSavingClass: PropTypes.bool,
    openChangeCourse: PropTypes.func,
    changeCourseIsActive: PropTypes.bool,
    changeCourseClassroomId: PropTypes.number,
    changeCourseGroupId: PropTypes.number,
    handleOnPrintTeacherSignInCard: PropTypes.func,
    downloadingTeachersIds: PropTypes.object,
    handleOnAssignTeacher: PropTypes.func,
    handleOnCancelDeleteGroupConfirmationBeforeSubmit: PropTypes.func,
    handleOnDeleteGroup: PropTypes.func,
    showDeleteNonEmptyGroupConfirmationModal: PropTypes.bool,
    showDeleteGroupConfirmationBeforeSubmit: PropTypes.bool,
    handleOnCloseDeleteGroupConfirmation: PropTypes.func,
    handleOnDeleteNonEmptyGroup: PropTypes.func,
    handleOnDeleteGroupRequest: PropTypes.func,
    openAddGroup: PropTypes.func,
    addGroupIsActive: PropTypes.bool,
    addGroupInProgress: PropTypes.bool,
    addGroupIsSuccess: PropTypes.bool,
    addGroupAddedGroup: PropTypes.object,
    handleOnManageStudents: PropTypes.func,
    handleOnManageStudentsBeforeDeleteGroup: PropTypes.func,
    handleOnStudentSignInCards: PropTypes.func,
    handleOnCancelStudentSignInCards: PropTypes.func,
    showHideSignInCardModal: PropTypes.bool,
    displayNewCourses: PropTypes.bool
};

export default injectIntl(styleable(css)(EditClassForm));



// WEBPACK FOOTER //
// ./app/components/edit-class-form/index.js